import React from "react";
import { Modal } from "antd";
import "./less/video-modal.style.less";
import VideoPlayer from "./VideoPlayer";

const VideoModal = ({ visible, setVisible, videoURL }) => {
    return (
        <Modal
            title={null}
            footer={null}
            open={visible}
            closable={false}
            onCancel={() => setVisible(false)}
            centered
            width={800}
            className="video-modal"
        >
            <VideoPlayer videoURL={videoURL} />
        </Modal>
    );
};

export default VideoModal;
